import {
    AppBar,
    IconButton,
    Toolbar,
    Typography,
    Grid,
    Box,
    FormControlLabel,
    Paper,
    MenuItem,
    Button,
    withStyles,
} from "@material-ui/core";

import React, { useContext, useEffect, useMemo, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { CommercialServices } from "lib/services/api/operaitons/WorkShop/TaskLibrary/commercial";
import { ToastMessageContext } from "lib/contexts/message_context";
import MaterialTable from "material-table";
import tableIcons, { options } from "components/universal/table_attributes";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import MROTextField from "components/form_components/TextField"
import MROButton from "components/buttons";
import { Search } from "@material-ui/icons";
import PositiveSwitch from "components/form_components/switch";
import MessagePopup from "components/universal/messagePopup";
import CreateApprovaCaution from "./CreateApprovaCaution";
import { WorkshopContext } from "../WorkshopContext/WorkshopContext";
import Checkbox from '@material-ui/core/Checkbox';
import moment from "moment";
import PartPricing from "./LookupPricing/PartPricing";
import { getUserId } from "lib/utils/common_utils";
import EstimationTable from "./EstimationTable";

import YesNoField from "components/form_components/YesNoField";
import CostDate from "./CostDate";
import CoreExchangeTable from "./CoreExchange/CoreExchangeTable";
import SelectedCoreDetails from "./CoreExchange/SelectedCoreDetails";
import PartSalesServices from "lib/services/api/commercial/parts";


const GreenCheckbox = withStyles({
    root: {
        color: "#4FC605",
        '&$checked': {
            color: "#4FC605",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    wrapper: {
        margin: "3%",
    },
    appBar: {
        backgroundColor: "#fff",
        color: "#000000CC",
        boxShadow: "0px 3px 6px #0000001A",
        fontSize: '14px'
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },
    title: {
        fontSize: '16px',
        color: theme.palette.primary.main
    }, title1: {
        fontSize: '14px',

    },
    detail: {
        backgroundColor: "#fff",
        padding: "1%",
    },
    spacing: {
        paddingTop: '15px', paddingBottom: '10px'
    },

    consolidatedTxt: {
        display: "flex", margin: '-23px 0px 20px 1px'

    },
    text: {
        fontSize: "12px"

    },
    button: {
        background: theme.palette.primary.main,
        width: "36px",
        height: " 36px",
        borderRadius: "5px"
    },
    diabledButton: {
        backgroundColor: "#707070",
        width: "36px",
        height: " 36px",
        borderRadius: "5px"
    }

}));




export default function CoreExchange(props) {
    const classes = useStyles();
    const {
        handleClose,
        jobData,
        estData,
        approvedPositionnData,
        currentSelectedOrder,
        currentPosition,
        getApprovedPosition,
        aog_fee_highest,
        permission
    } = props;


    const [action, setAction] = useState(null);
    const [currentSelection, setCurrentSelection] = useState({});
    const [errors, setErrors] = useState({});

    const { setApprovalStateCommercial, approvalStateCommercial, } = useContext(WorkshopContext);
    let aog_fee_new = parseFloat((+aog_fee_highest ?? 0) - (+approvedPositionnData?.aog_fee ?? 0)).toFixed(2)
    const [input, setInput] = useState({
        tat_days: "",
        labour_value: "",
        parts_value: "",
        service_value: "",
        equipment_value: "",
        aog_fee: "",
    });

    const [selectedException, setSetSelectionException] = useState([])
    const [sum, setSum] = useState(null);
    const [initilaSum, setInitialSum] = useState(null);
    const [selectedSum, setSelectedSum] = useState(null);
    const [revisedtotal, setRevisedTotal] = useState(null)
    const [revisedInitialtotal, setRevisedInitialTotal] = useState(null)
    const [confirmationPopup, setConfirmationPopup] = useState(false)
    const [acceptAll, setAcceptAll] = useState(false)
    const [popupValues, setPopUpValues] = useState({})
    const [messagePopup, setMessagePopup] = useState(false)
    const [formvalues, setFormvalues] = useState({})
    const [busy, setBusy] = useState(null);
    const message = useContext(ToastMessageContext);
    const [exceptionData, setExceptionData] = useState([])
    const [disabled, setDisabled] = useState(false)
    const [loading, setLoading] = useState(false)
    const [standardId, setStandardId] = useState(null)
    const [etd, setETD] = useState(null)
    const [tatDays, setTatDays] = useState("")
    const [totalTat, setTotalTat] = useState(null)
    const [tableInput, setTableInput] = useState({
        labour_cost: 0, parts_cost: 0, service_cost: 0, equipment_cost: 0
    })
    const [planningVerfication, setPlanningVerification] = useState([])
    const [initialInput, setInitialInput] = useState({
        tat_days: "",
        labour_value: "",
        parts_value: "",
        service_value: "",
        equipment_value: "",
        aog_fee: "",
    });

    const [selectedInput, setSelectedInput] = useState({
        tat_days: 0.00,
        labour_value: 0.00,
        parts_value: 0.00,
        service_value: 0.00,
        equipment_value: 0.00,
        aog_fee: +aog_fee_new ?? 0.00,
    });
    const [repairFee, setRepairFees] = useState('yes');
    const [costData, setCostData] = useState({
        labour: "",
        parts: "",
        service: "",
        equipment: "",
        total: ""
    })

    const [coreValues, setCoreValues] = useState({

        repairFees: "",
        traceFees: "",
        lateFees: ""
    })
    const [coreData, setCoreData] = useState([])
    const [shippingFee, setShippingFee] = useState(0)
    const [lateFee, setLateFee] = useState(0)

    const shouldShowPopup =

        !["repair", "lookup", "trace_document"].includes(action) &&
        action !== null;
    const getCostDetails = async () => {
        const params = { workshop_order_id: currentSelectedOrder.id };

        try {
            const response = await PartSalesServices.getCostDetails(params);


            if (response?.data) {

                setCostData(response?.data)
            } else {
                setCostData([]);
            }
        } catch (error) {
            console.error("Error in getDetails:", error);
            setCostData([]);
        }
    };

    useEffect(() => {
        if (currentSelectedOrder.id) {
            getCostDetails()
        }
    }, [currentSelectedOrder])
    const getList = async () => {
        const params = {
            // page: 1 + page,
            // limit: pageSize,
            workshop_order_id: currentSelectedOrder.id,


        };
        setLoading(true)
        CommercialServices.getExceptionTableListing(params).then((res) => {

            if (res.success) {
                let data = res?.data

                if (data.length > 0) {
                    let value = data.map((item) => {
                        if (item.commercial_type === 1) {
                            item.status = true
                        }
                        return item
                    })

                    let selectedValue = value.filter((item) => {
                        if (item.status === true) {
                            return item.id

                        }
                    })
                    if (selectedValue.length > 0) {
                        let array1 = selectedValue.map((item) => {
                            return item.id
                        })
                        setSetSelectionException(array1)

                        //calculation
                        const initialValues = {
                            labour_cost: 0,
                            parts_cost: 0,
                            service_cost: 0,
                            equipment_cost: 0,
                        };
                        const rowData = selectedValue.reduce(
                            (acc, item) => {
                                acc.labour_cost += +item.labour_cost || 0;
                                acc.parts_cost += +item.parts_cost || 0;
                                acc.service_cost += +item.service_cost || 0;
                                acc.equipment_cost += +item.equipment_cost || 0;
                                return acc;
                            },
                            { ...initialValues }
                        );

                        setTableInput(rowData)
                        handleCalculation(rowData, true)




                    }



                }

                setExceptionData(res.data)

            }
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    };
    useEffect(() => {
        if (approvedPositionnData !== null) {
            let value = {
                tat_days: +approvedPositionnData?.tat || 0,
                labour_value: +approvedPositionnData?.labour || 0,
                parts_value: +approvedPositionnData?.parts || 0,
                service_value: +approvedPositionnData?.services || 0,
                equipment_value: +approvedPositionnData?.equipment || 0,
                aog_fee: +approvedPositionnData?.aog_fee || 0,
            }
            setInitialInput(value);
            let value1 = { ...value, aog_fee: +aog_fee_new + (+approvedPositionnData?.aog_fee || 0) }
            setInput(value1);


        }
    }, [approvedPositionnData])

    useEffect(() => {
        if (exceptionData.length > 0) {
            let data = exceptionData.filter((item) => item.planning_verification === false)
            setPlanningVerification(data)
        }
    }, [exceptionData])


    useEffect(() => {
        if (exceptionData.length > 0 && selectedException.length > 0) {
            let selectedValue = exceptionData.map((item) => {
                selectedException.filter((excep) => {
                    if (excep === item.id) {
                        item.status = true
                    }
                    // return item
                })
                return item
            })

        }
    }, [exceptionData, selectedException])


    useEffect(() => {
        if (repairFee === "yes") { getList(); }
    }, [repairFee]);

    useEffect(() => {
        if (approvedPositionnData !== null) {
            setTotalTat(approvedPositionnData?.tat ? approvedPositionnData?.tat : 0)
            setStandardId(approvedPositionnData?.standard_id)
            setTatDays(approvedPositionnData?.tat_remaining)
        }
    }, [approvedPositionnData])








    const resetErrorsHandler = (name) => {
        setErrors((e) => ({ ...e, [name]: false }));
    };
    const handleInput = function (e) {
        const { value, name } = e.target;

        // allow only digits and a single decimal point (allow leading "-" for aog_fee)
        const numberPattern = name === "aog_fee" ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
        if (value !== "" && !numberPattern.test(value)) {
            return;
        }

        if (value.match(/\./g)) {
            const [, decimal] = value.split(".");

            // restrict value to only 2 decimal places
            if (decimal?.length > 2) {
                // do nothing
                return;
            }
        }
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };
    useEffect(() => {
        if (tatDays !== null && tatDays !== undefined) {
            let today = moment().format("DD/MM/YYYY")
            let tat = tatDays ? tatDays : 0
            let date = today ? moment(today, "DD/MM/YYYY").add(tat, "days").format("DD/MM/YYYY") : null
            setETD(date)
            if (date) {
                let date_format = "DD/MM/YYYY"
                let c_etd = moment(date, date_format)
                let inducted = currentSelectedOrder?.inducted_start ? moment(currentSelectedOrder?.inducted_start, "DD/MM/YYYY HH:mm:ss").format(date_format) : null

                if (inducted !== null) {
                    let i_date = moment(inducted, date_format)
                    let final_date = c_etd.diff(i_date, "days")

                    setTotalTat(final_date)
                }
            }

        }
    }, [tatDays])
    useMemo(
        () =>
            setSum(
                +input.labour_value +
                +input.parts_value +
                +input.service_value +
                +input.equipment_value +
                +input.aog_fee
            ),
        [input]
    );


    useMemo(
        () =>
            setInitialSum(
                +initialInput.labour_value +
                +initialInput.parts_value +
                +initialInput.service_value +
                +initialInput.equipment_value +
                +initialInput.aog_fee
            ),
        [initialInput]
    );
    useMemo(
        () =>
            setSelectedSum(
                +selectedInput.labour_value +
                +selectedInput.parts_value +
                +selectedInput.service_value +
                +selectedInput.equipment_value +
                +selectedInput.aog_fee
            ),
        [selectedInput]
    );

    useEffect(() => {
        setCoreValues((ps) => ({ ...ps, repairFees: selectedSum ? parseFloat(selectedSum).toFixed(2) : 0 }))
    }, [selectedSum])

    useEffect(() => {
        setCoreValues((ps) => ({ ...ps, lateFees: lateFee ? parseFloat(lateFee).toFixed(2) : 0 }))
    }, [lateFee])
    useEffect(() => {
        setConfirmationPopup(false)
    }, [action])
    useMemo(
        () =>
            setRevisedTotal(
                +input.labour_value +
                +input.parts_value +
                +input.service_value +
                +input.equipment_value
            ),
        [input]
    );
    useMemo(
        () =>
            setRevisedInitialTotal(
                +initialInput.labour_value +
                +initialInput.parts_value +
                +initialInput.service_value +
                +initialInput.equipment_value
            ),
        [initialInput]
    );



    useEffect(() => {
        if (repairFee === "no") {
            const rowData = {
                labour_cost: +costData.labour,
                parts_cost: +costData.parts,
                service_cost: +costData.service,
                equipment_cost: +costData.equipment,
            }
            setSetSelectionException([])
            handleCalculation(rowData, true)
        }
    }, [repairFee, costData])
    const handleRepairFee = (value) => {

        if (value) {

            let r_value = value === "yes" ? {
                labour_cost: +costData.labour,
                parts_cost: +costData.parts,
                service_cost: +costData.service,
                equipment_cost: +costData.equipment,
            } : {
                labour_cost: +selectedInput.labour_value,
                parts_cost: +selectedInput.parts_value,
                service_cost: +selectedInput.service_value,
                equipment_cost: +selectedInput.equipment_value,

            }
            handleMinusCalculation(r_value)
            setSelectedInput({
                ...selectedInput, labour_value: 0.00,
                parts_value: 0.00,
                service_value: 0.00,
                equipment_value: 0.00
            })
            setRepairFees(value);


        }
    }
    const exceptionColumn = [
        {
            title: "Action",
            field: "action_number",
            headerStyle: {
                textAlign: "left",
                paddingLeft: '15px'
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: '15px'
            },


        },
        {
            title: "Type",
            field: "action_category",
            headerStyle: {
                textAlign: "left",

            },
            cellStyle: {
                textAlign: "left",

            },
        },
        {
            title: "Description",
            field: "title",
            width: "40%",

            headerStyle: {
                textAlign: "left",
                width: "40%",
            },
            cellStyle: {
                textAlign: "left",
                width: "40%",
            },
        },
        {
            title: "Labour",
            field: "labour_cost",
        },

        {
            title: "Parts",
            field: "parts_cost",
        },

        {
            title: "Services",
            field: "service_cost",
        },

        {
            title: "Equipment",
            field: "equipment_cost",
        },
        {
            title: "Overall",
            field: "overview_total",
        },



        {
            title: "Action",
            field: "",
            render: (rowData) => <div>
                <FormControlLabel
                    control={<GreenCheckbox checked={rowData?.status} onChange={(e) => {
                        handleExceptionTable(rowData)
                    }} name="" />}
                    label=""
                />

            </div>

        },

    ]
    const handleExceptionTable = (rowData) => {

        let value = exceptionData.map((item) => {
            if (item.id === rowData.id) {
                item.status = !rowData?.status
            }
            return item
        })
        setExceptionData(value)

        if (rowData?.status === false) {
            handleMinusCalculation(rowData)
            let indexExp = selectedException.filter(item => item !== rowData?.id)
            setSetSelectionException(indexExp)

        }
        else {
            selectedException.push(rowData.id)
            handleCalculation(rowData)
        }


    }

    const handleCalculation = (rowData, includeApproved = false) => {
        // Update selectedInput\\

        const updatedSelectedInput = {
            labour_value: parseFloat(+selectedInput.labour_value + rowData.labour_cost).toFixed(2),
            parts_value: parseFloat(+selectedInput.parts_value + rowData.parts_cost).toFixed(2),
            service_value: parseFloat(+selectedInput.service_value + rowData.service_cost).toFixed(2),
            equipment_value: parseFloat(+selectedInput.equipment_value + rowData.equipment_cost).toFixed(2),
            aog_fee: parseFloat(+selectedInput.aog_fee).toFixed(2),
        };
        const updatedSelectedCostInput = {

            labour_value: parseFloat(costData.labour).toFixed(2),
            parts_value: parseFloat(costData.parts).toFixed(2),
            service_value: parseFloat(costData.service).toFixed(2),
            equipment_value: parseFloat(costData.equipment).toFixed(2),
            aog_fee: parseFloat(+selectedInput.aog_fee).toFixed(2),

        }
        // Add approved data if includeApproved is true
        const approvedValues = includeApproved
            ? {
                labour: +approvedPositionnData?.labour || 0,
                parts: +approvedPositionnData?.parts || 0,
                services: +approvedPositionnData?.services || 0,
                equipment: +approvedPositionnData?.equipment || 0,
                aog_fee: +approvedPositionnData?.aog_fee || 0,
            }
            : {
                labour: 0,
                parts: 0,
                services: 0,
                equipment: 0,
                aog_fee: 0,
            };
        const currentValue = repairFee === "yes" ? {

            labour: +rowData.labour_cost || 0,
            parts: +rowData.parts_cost || 0,
            services: + rowData.service_cost || 0,
            equipment: +rowData.equipment_cost || 0,

        } : {
            labour: +costData.labour || 0,
            parts: +costData.parts || 0,
            services: +costData.service || 0,
            equipment: +costData.equipment || 0,
        }
        // Update input
        const updatedInput = {
            labour_value: parseFloat(
                +input.labour_value + currentValue.labour + (includeApproved ? approvedValues.labour : 0)
            ).toFixed(2),
            parts_value: parseFloat(
                +input.parts_value + currentValue.parts + (includeApproved ? approvedValues.parts : 0)
            ).toFixed(2),
            service_value: parseFloat(
                +input.service_value + currentValue.services + (includeApproved ? approvedValues.services : 0)
            ).toFixed(2),
            equipment_value: parseFloat(
                +input.equipment_value + currentValue.equipment + (includeApproved ? approvedValues.equipment : 0)
            ).toFixed(2),
            aog_fee: parseFloat(+input.aog_fee + (+selectedInput.aog_fee || 0) + (includeApproved ? approvedValues.aog_fee : 0)).toFixed(2),
            tat_days: +input.tat_days,
        };



        setSelectedInput(repairFee === "yes" ? updatedSelectedInput : updatedSelectedCostInput);
        setInput(updatedInput);
    };

    const handleMinusCalculation = (rowData) => {

        setSelectedInput({
            labour_value: parseFloat(+selectedInput.labour_value - rowData.labour_cost).toFixed(2),
            parts_value: parseFloat(+selectedInput.parts_value - rowData.parts_cost).toFixed(2),
            service_value: parseFloat(+selectedInput.service_value - rowData.service_cost).toFixed(2),
            equipment_value: parseFloat(+selectedInput.equipment_value - rowData.equipment_cost).toFixed(2),
            aog_fee: 0
        });
        setInput({
            labour_value: parseFloat(+input.labour_value - rowData.labour_cost).toFixed(2),
            parts_value: parseFloat(+input.parts_value - rowData.parts_cost).toFixed(2),
            service_value: parseFloat(+input.service_value - rowData.service_cost).toFixed(2),
            equipment_value: parseFloat(+input.equipment_value - rowData.equipment_cost).toFixed(2),
            aog_fee: +input.aog_fee || 0,
            tat_days: +input.tat_days
        });



    }

    useEffect(() => {
        if (selectedInput) {
            setTableInput({
                labour_cost: +selectedInput.labour_value,
                parts_cost: +selectedInput.parts_value,
                service_cost: +selectedInput.service_value,
                equipment_cost: +selectedInput.equipment_value,
                aog_cost: +selectedInput.aog_fee
            });

        }
    }, [selectedInput])
    useEffect(() => {
        if (initialInput && approvedPositionnData?.total === null) {
            let value_selected = {
                labour_value: parseFloat(+initialInput.labour_value + tableInput.labour_cost).toFixed(2),
                parts_value: parseFloat(+initialInput.parts_value + tableInput.parts_cost).toFixed(2),
                service_value: parseFloat(+initialInput.service_value + tableInput.service_cost).toFixed(2),
                equipment_value: parseFloat(+initialInput.equipment_value + tableInput.equipment_cost).toFixed(2),
                aog_fee: parseFloat(+initialInput.aog_fee + tableInput.aog_cost).toFixed(2),


            }
            // console.log("selected====", tableInput, value_selected)

            setInput(value_selected);



        }



    }, [initialInput])



    const tableOptions = {
        ...options,
        paging: false,
        search: false,


    };
    const handleReport = (rowData) => {

        let reportStatus = reportData.map((item) => {
            if (item.id === rowData.id) {
                item.status = !rowData?.status
            }
            return item
        })
        setReportData(reportStatus)

    }
    const reportColumn = [
        {
            title: "Item",
            field: "item",
            headerStyle: {
                textAlign: "left",
                paddingLeft: '15px'
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: '15px'
            },


        },
        {
            title: "Detail",
            field: "details",
            width: "60%",

            headerStyle: {
                textAlign: "left",
                width: "60%",
            },
            cellStyle: {
                textAlign: "left",
                width: "60%",
            },
        },
        {
            title: "Action",
            field: "",
            render: (rowData) => <div>
                <FormControlLabel
                    control={
                        <PositiveSwitch
                            checked={rowData?.status}
                            onChange={(e) => {
                                handleReport(rowData)
                            }}
                        />
                    }
                    label=""
                    labelPlacement=""
                // name={"show_all_issued_items"}
                />

            </div>

        },

    ]


    const [reportData, setReportData] = useState([

        {
            item: "Detailed Costs",
            details: "Show additional breakdown of Labour, Parts, Service and Equipment Costs in ALL Cost sections of the Commercial Report?",
            status: false,
            name: "cost_breakdown_detail",
            id: 3
        }, {
            item: "Detailed CSV",
            details: "Send detailed “Cost Breakdown Report CSV” with the report?",
            status: false,
            name: "costs_csv",
            id: 4
        }, {
            item: "Workshop Report",
            details: "Send Workshop Report with to date Actions and Stage progress?",
            status: false,
            name: "workshop_report",
            id: 5
        }, {
            item: "Do NOT send Report",
            details: "Do not send anything to the customer in relation to this approval?",
            status: false,
            name: "do_not_send",
            id: 6

        },



    ])
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        // const { error, valid } = validateFormData(formData, ["send_report_to_customer", "receipt_charge", "receipt_type"]);
        let c_date = formData.get("calculated_etd")

        let optionalFields = ["send_report_to_customer", "receipt_charge", "receipt_type"]
        let format = "DD/MM/YYYY"
        let today = moment()
        let valid = true;
        let error = {};

        for (const pair of formData.entries()) {
            const key = pair[0];
            const value = pair[1];

            // console.log("value is===================", optionalFields)

            if (value === "select" || value === "Search") {
                error[key] = true;
                valid = false;
            }

            if (value === "" && !optionalFields.includes(key)) {
                error[key] = true;
                valid = false;
            }
        }


        if (moment(c_date, format).isBefore(moment(today, format))) {
            valid = false;
            error = {
                ...error,
                calculated_etd: "ETD cannot be less than today!"

            };
        }

        // console.log("date====", c_date)
        if (!valid) {
            setBusy(null);
            setErrors(error);
            return;
        }
        setBusy("loading");

        formData.delete("calculated_etd")
        formData.append("calculated_etd", moment(etd, "DD/MM/YYYY").format("YYYY-MM-DD"))

        // formData.delete("tat_days")
        formData.delete("labour_value")
        formData.delete("parts_value")
        formData.delete("service_value")
        formData.delete("equipment_value")
        formData.delete("aog_fee")
        formData.delete("total")
        formData.delete("initial_total")
        // formData.append("tat_days", tatDays)
        formData.append("labour_value", input.labour_value || "")
        formData.append("parts_value", input.parts_value || "")
        formData.append("service_value", input.service_value || "")
        formData.append("equipment_value", input.equipment_value || "")
        formData.append("aog_fee", input.aog_fee || "")
        formData.append("total", parseFloat(revisedtotal).toFixed(2) || "")
        formData.append("initial_total", parseFloat(revisedInitialtotal).toFixed(2) || "")
        formData.append("workshop_order_id", currentSelectedOrder?.id);
        formData.append("user_id", getUserId());
        formData.append("labour_cost_to_date", costData?.labour);
        formData.append("parts_cost_to_date", costData?.parts);
        formData.append("services_cost_to_date", costData?.service);
        formData.append("equip_cost_to_date", costData?.equipment);
        formData.append("total_cost_to_date", costData?.total);

        reportData.forEach((item) => formData.append(`${item.name}`, item.status))


        if (selectedException.length > 0) {
            selectedException.forEach((item, index) => formData.append(`action_id[${index}]`, item))
        }
        formData.append("approval_type", 2)
        formData.append("sales_order_core_id", currentSelectedOrder?.sales_order_core_id)
        formData.delete("core_accepted")
        formData.append("core_accepted", repairFee === "yes" ? true : false)
        if (standardId !== null) {
            formData.append("workshop_standard_price_id", standardId)
        }
        let shipping = +shippingFee
        let penalty = +coreValues?.lateFees + (+coreValues?.traceFees)
        let total_core = (+shipping || 0) + (+penalty || 0) + (+coreValues?.repairFees || 0)
        setPopUpValues({
            core_exchange: coreData.length,
            shipping: shipping.toFixed(2),
            penalities: penalty.toFixed(2),
            repair: (+coreValues?.repairFees).toFixed(2),
            total: total_core.toFixed(2)
        })

        if (valid && action === null) {

            setConfirmationPopup(true)
            setFormvalues(formData)

        }



    };


    const handlePopUp = async (e, id) => {
        setMessagePopup(true)
        const params = {
            preview: true,
            approved: true,
            approved_position_id: id
        }
        await CommercialServices.createNewApproval(params, formvalues)
            .then((res) => {
                if (res) {
                    handleClose(res.success);
                    setApprovalStateCommercial(res.success);
                    getApprovedPosition();
                    message.showToastMessage({
                        message: res?.message ? res?.message : "Created successfully!!",
                        variant: "success",
                    });
                }
            })
            .catch(() => {
                message.showToastMessage({
                    message: "Something went wrong. Try again!!",
                    variant: "error",
                });
            })
            .finally(() => {
                setBusy(null);
                setMessagePopup(false)
            });

    }



    return (
        <div>

            <form onSubmit={handleSubmit}>

                <div style={{ margin: "3%" }} >
                    <div className={classes.consolidatedTxt} >
                        <InfoOutlinedIcon />
                        &nbsp;&nbsp;
                        <Typography variant="subtitle1" className={classes.text} >
                            Use Initial & Exceptions method for to capture an Initial Charges (quote or standard charges) and subsequent Exceptions (defects etc)
                        </Typography>
                    </div>
                    <Typography variant="subtitle2" className={classes.title1}>Estimated Departure</Typography>
                    <div className={classes.spacing}>
                        Current Approved and Revised ETDs
                    </div>


                    <Box className={classes.spacing}>
                        <EstimationTable data={estData} loading={loading} setAction={setAction} setCurrentSelection={setCurrentSelection} currentSelection={currentSelection} action={action} />

                    </Box>
                    <div className={classes.spacing}>
                        Update Approved ETD as required
                    </div>
                    <Grid
                        container
                        spacing={2}
                        alignItems={"center"}
                        justify={"flex-start"}
                        xs={12}
                    >
                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"tat_remaining"}
                                label={"TAT Remaining (Days) *"}
                                defaultValue={approvedPositionnData?.tat_remaining}
                                type="text"
                                value={tatDays}
                                placeholder={""}
                                InputLabelProps={{ shrink: true }}

                                error={errors.tat_remaining}
                                onChange={(e) => {
                                    resetErrorsHandler("tat_remaining");
                                    setTatDays(e.target.value)
                                    handleInput(e);
                                    setErrors({ ...errors, tat_remaining: false })
                                }}
                            ></MROTextField>
                        </Grid>
                        <Grid item>
                            <MROTextField
                                name={"tat_days"}
                                label={"TAT (Days)*"}
                                defaultValue={approvedPositionnData?.tat}
                                value={totalTat}
                                type="text"
                                placeholder={"0.00"}
                                error={errors.tat_days}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    setTotalTat(e.target.value)
                                }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>

                        </Grid>
                        <Grid item xs={4}>
                            <MROTextField
                                name={"calculated_etd"}
                                label={"Calculated ETD *"}
                                defaultValue={approvedPositionnData?.etd}
                                value={etd}
                                type="text"
                                width="123px"
                                placeholder={""}
                                error={errors.calculated_etd}
                                helperText={errors.calculated_etd ? errors.calculated_etd : !errors.calculated_etd ? null : "*please enter a ETA"}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    // handleInput(e);
                                    setErrors({ ...errors, calculated_etd: false })
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>



                    </Grid>

                    <div className={classes.spacing}>
                        <Typography variant="subtitle2" className={classes.title1} >Initial </Typography>
                        <div style={{ paddingTop: '10px' }}>
                            For internal purposes an initial value should be added, typically from a Standard Price. This value will not be displayed in the Commercial Report to the Customer.
                        </div>
                        <Grid container style={{ paddingTop: '10px' }} >
                            <Grid>
                                <IconButton className={approvedPositionnData?.total !== null ? classes.diabledButton : classes.button} onClick={() => {
                                    setAction("lookup")
                                    setConfirmationPopup(false)
                                }} style={{ pointerEvents: approvedPositionnData?.total !== null ? "none" : "" }}>
                                    <Search htmlColor="#fff" fontSize="small" style={{ fontSize: '25px' }} />
                                </IconButton>
                            </Grid>
                            <Grid><Typography style={{ padding: " 7px", fontSize: "14px" }}>Lookup from Standard Pricing or Job History</Typography> </Grid>

                        </Grid>

                    </div>
                    <div style={{ paddingTop: '10px' }}>
                        Initial Approved Position Values
                    </div>

                    <Grid
                        container
                        spacing={2}
                        alignItems={"center"}
                        justify={"flex-start"}
                        xs={12}
                        className={classes.spacing}
                    >
                        <Grid item >
                            <MROTextField
                                label={"Order QTY"}
                                defaultValue={currentSelectedOrder?.quantity || 1}
                                type="text"
                                width="120px"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"initial_labour"}
                                label={"Labour *"}
                                value={initialInput.labour_value}
                                type="text"
                                width="120px"
                                placeholder={"0.00"}
                                InputProps={{
                                    className: approvedPositionnData?.labour == null ? "" : classes.disableField,
                                }}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    setInitialInput({ ...initialInput, labour_value: e.target.value })
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>

                        <Grid item >
                            <MROTextField
                                name={"initial_parts"}
                                label={"Parts *"}
                                value={initialInput.parts_value}
                                type="text"
                                width="120px"
                                placeholder={"0.00"}
                                InputProps={{
                                    className: approvedPositionnData?.parts === null ? "" : classes.disableField,
                                }}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    setInitialInput({ ...initialInput, parts_value: e.target.value })

                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"initial_service"}
                                width="120px"
                                label={"Services *"}
                                value={initialInput.service_value}
                                type="text"
                                placeholder={"0.00"}
                                InputProps={{
                                    className: approvedPositionnData?.services === null ? "" : classes.disableField,

                                }}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    setInitialInput({ ...initialInput, service_value: e.target.value })

                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"initial_equipment"}
                                label={"Equipment *"}
                                width="120px"
                                value={initialInput.equipment_value}
                                placeholder={"0.00"}
                                type="text"
                                InputProps={{
                                    className: approvedPositionnData?.equipment === null ? "" : classes.disableField,
                                }}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    setInitialInput({ ...initialInput, equipment_value: e.target.value })

                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"initial_aog"}
                                label={"Other *"}
                                value={initialInput.aog_fee}
                                placeholder={"0.00"}
                                type="text"
                                width="120px"
                                InputProps={{
                                    // className: approvedPositionnData?.aog_fee === null ? "" : classes.disableField
                                }}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value !== "" && !/^-?\d*\.?\d*$/.test(value)) {
                                        return;
                                    }
                                    setInitialInput({ ...initialInput, aog_fee: value })
                                    setInput({ ...input, aog_fee: (+value + (+selectedInput?.aog_fee)) })
                                    resetErrorsHandler(e.target.name)
                                }}
                                InputLabelProps={{ shrink: true }}

                            ></MROTextField>
                        </Grid>

                        <Grid item >
                            <MROTextField
                                name={"initial_total"}
                                label={"Total *"}
                                width="120px"
                                value={parseFloat(initilaSum).toFixed(2)}
                                placeholder={"0.00"}
                                defaultValue={0.0}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}


                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                label={"Currency"}
                                defaultValue={currentPosition?.currency}
                                type="text"
                                width="120px"
                                placeholder={"USD"}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>






                    </Grid>
                    <Typography variant="subtitle2" className={classes.title1}>Penalty Fees</Typography>

                    <SelectedCoreDetails currentSelection={{ id: currentSelectedOrder?.sales_order_core_id }} setCoreValues={setCoreValues} setAction={setAction} action={action} setConfirmationPopup={setConfirmationPopup} permission={permission} />
                    <Typography variant="subtitle2" className={classes.title1}>Repair Fees</Typography>
                    <Grid item xs={6}
                        style={{ background: "transparent" }}
                    >
                        <YesNoField

                            label="Core Exchange item Repairs accepted?"
                            name="core_accepted"
                            handleToggle={handleRepairFee}
                            value={repairFee}
                            error={errors.core_accepted}
                            setError={() => {
                                resetErrorsHandler("core_accepted");
                            }}
                            marginTop={"-4px"}
                            marginRight={"11px"}
                        />
                    </Grid>



                    {repairFee === "no" ? <>
                        <div className={classes.spacing}>
                            Costs to date from this Workshop Order are carried forward should the customer choose to return a further / additional exchange item
                        </div>
                        <CostDate workshopId={currentSelectedOrder.id} setCostData={setCostData} handleCalculation={handleMinusCalculation} tab={"core"} />
                    </> :

                        <>


                            <Grid><Typography style={{ paddingTop: " 7px", fontSize: "14px", paddingBottom: "10px" }}>Select the exception / defects that go beyond the initial Approved Position scope of work</Typography> </Grid>

                            <Paper style={{ paddingBottom: "15px" }}>
                                <Box className={classes.spacing} style={{ height: '350px', overflow: "scroll", paddingLeft: "19px", paddingRight: "15px" }}>

                                    <MaterialTable
                                        style={{
                                            boxShadow: "0zpx 1px 4px #00000033",
                                            //   marginTop: "10px",
                                            maxBodyHeight: "350px"
                                        }}
                                        isLoading={loading}
                                        icons={tableIcons}
                                        title={""}
                                        columns={exceptionColumn}
                                        data={exceptionData || []}
                                        options={tableOptions}

                                    />

                                </Box>
                            </Paper>





                        </>




                    }

                    <div style={{ paddingTop: '15px' }}>
                        Selected repair values
                    </div>

                    {/* selected exceptions */}
                    <Grid
                        container
                        spacing={2}
                        alignItems={"center"}
                        justify={"flex-start"}
                        xs={12}
                        className={classes.spacing}
                    >
                        <Grid item >
                            <MROTextField
                                label={"Order QTY"}
                                defaultValue={currentSelectedOrder?.quantity || 1}
                                type="text"
                                width="120px"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                label={"Labour *"}
                                value={selectedInput.labour_value}
                                type="text"
                                width="120px"
                                placeholder={"0.00"}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>

                        <Grid item >
                            <MROTextField

                                label={"Parts *"}
                                value={selectedInput.parts_value}
                                type="text"
                                width="120px"
                                placeholder={"0.00"}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField

                                width="120px"
                                label={"Services *"}
                                value={selectedInput.service_value}
                                placeholder={"0.00"}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField

                                label={"Equipment *"}
                                width="120px"
                                value={selectedInput.equipment_value}
                                placeholder={"0.00"}
                                type="text"
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                label={"Other *"}
                                value={selectedInput.aog_fee}
                                placeholder={"0.00"}
                                type="text"
                                width="120px"
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value !== "" && !/^-?\d*\.?\d*$/.test(value)) {
                                        return;
                                    }
                                    setSelectedInput({ ...selectedInput, aog_fee: value })
                                    setInput({ ...input, aog_fee: (+value + (+initialInput?.aog_fee)) })
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>

                        <Grid item >
                            <MROTextField
                                label={"Total *"}
                                width="120px"
                                value={parseFloat(selectedSum).toFixed(2)}
                                placeholder={"0.00"}
                                defaultValue={0.0}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                label={"Currency"}
                                defaultValue={currentPosition?.currency}
                                type="text"
                                width="120px"
                                placeholder={"USD"}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>




                    </Grid>




                    {/* commercial sections tab1*/}


                    <div className={classes.spacing}>
                        <Typography variant="subtitle2" className={classes.title1} >Commercial Values</Typography>

                        <div style={{ paddingTop: '10px' }}>
                            Workshop Order TOTAL value in the Customer’s currency - internal reference only!
                        </div>
                    </div>


                    <Grid
                        container
                        spacing={2}
                        alignItems={"center"}
                        justify={"flex-start"}
                        xs={12}
                        className={classes.spacing}
                    >
                        <Grid item >
                            <MROTextField
                                label={"Order QTY"}
                                defaultValue={currentSelectedOrder?.quantity || 1}
                                type="text"
                                width="120px"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}

                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"labour_value"}
                                label={"Labour *"}
                                value={input.labour_value}
                                type="text"
                                width="120px"
                                placeholder={"0.00"}
                                // error={errors.tat_days}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    handleInput(e);
                                }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>

                        <Grid item >
                            <MROTextField
                                name={"parts_value"}
                                label={"Parts *"}
                                value={input.parts_value}
                                type="text"
                                width="120px"
                                placeholder={"0.00"}
                                error={errors.parts_value}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    handleInput(e);
                                }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"service_value"}
                                width="120px"
                                label={"Services *"}
                                value={input.service_value}
                                type="text"
                                placeholder={"0.00"}
                                error={errors.service_value}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    handleInput(e);
                                }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"equipment_value"}
                                label={"Equipment *"}
                                width="120px"
                                value={input.equipment_value}
                                placeholder={"0.00"}
                                type="text"
                                error={errors.equipment_value}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    handleInput(e);
                                }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                name={"aog_fee"}
                                label={"Other *"}
                                value={input.aog_fee}
                                placeholder={"0.00"}
                                type="text"
                                width="120px"
                                error={errors.aog_fee}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                    handleInput(e);
                                }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                InputLabelProps={{ shrink: true }}
                            ></MROTextField>
                        </Grid>

                        <Grid item >
                            <MROTextField
                                name={"total"}
                                label={"Total *"}
                                width="120px"
                                error={errors.total}
                                value={parseFloat(sum).toFixed(2)}
                                placeholder={"0.00"}
                                defaultValue={0.0}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                }}

                            ></MROTextField>
                        </Grid>
                        <Grid item >
                            <MROTextField
                                label={"Currency"}
                                defaultValue={currentPosition?.currency}
                                type="text"
                                width="120px"
                                placeholder={"USD"}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    className: classes.disableField,
                                }}
                            ></MROTextField>
                        </Grid>




                    </Grid>
                    <Typography variant="subtitle2" className={classes.title1}>Core Exchange Summary</Typography>

                    <CoreExchangeTable
                        coreId={currentSelectedOrder?.core_parent_id}
                        sales_order_core_id={currentSelectedOrder?.sales_order_core_id}
                        repairFee={repairFee}
                        c_action={"edit"}
                        coreValues={coreValues}
                        setShippingFee={setShippingFee}
                        setCoreData={setCoreData}
                        currency_id={""}
                        setLateFee={setLateFee}
                        permission={permission}
                    />


                    {/* comments Sections tab1*/}
                    <Typography variant="subtitle2" className={classes.title1}>Commercial Report Comments</Typography>

                    <Grid
                        container
                        spacing={2}
                        alignItems={"center"}
                        justify={"flex-start"}
                        xs={12}
                        className={classes.spacing}
                    >

                        <Grid item xs={12}>
                            <MROTextField
                                name={"comments"}
                                label={"Comments *"}
                                type="text"
                                multiline
                                placeholder={"Add comments you wish to appear on your commercial report summary - Max 250 Characters"}
                                error={errors.comments}
                                onChange={(e) => {
                                    resetErrorsHandler(e.target.name);
                                }}
                                defaultValue={approvedPositionnData?.comment || ""}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 250 }}
                                InputProps={{
                                    style: {
                                        height: 'max-content',
                                        width: "100%",

                                    },
                                }}
                            ></MROTextField>
                        </Grid>





                    </Grid>

                    {/* report sections */}
                    <div className={classes.spacing}>
                        <Typography variant="subtitle2" className={classes.title1}>Commercial Report Options</Typography>
                    </div>
                    <Box className={classes.spacing}>
                        <MaterialTable
                            style={{
                                boxShadow: "0px 1px 4px #00000033",
                                //   marginTop: "10px",
                            }}
                            isLoading={''}
                            icons={tableIcons}
                            title={""}
                            columns={reportColumn}
                            data={reportData || []}
                            options={tableOptions}
                            components={{
                                Toolbar: () => null,
                            }}
                            localization={{
                                toolbar: {},
                                body: {
                                    emptyDataSourceMessage: "No Records found",
                                    filterRow: {
                                        filterTooltip: "Filter",
                                    },
                                },
                            }}
                        />
                    </Box>


                    <div style={{ marginLeft: "0px" }} className={"action-buttons"}>
                        <MROButton
                            // loading={busy === "loading"}
                            variant={"contained"}
                            color={"primary"}
                            type="submit"
                            disabled={confirmationPopup}
                        >
                            Complete
                        </MROButton>
                    </div>





                </div>





            </form >
            {action === "lookup" && (
                <PartPricing handleClose={() => {
                    setAction(null)
                    setConfirmationPopup(false)
                }} currentWorkshopDetails={{ quantity: currentSelectedOrder?.quantity || 1, part_number: currentSelectedOrder?.part_number, description: currentSelectedOrder?.description, salesRate: approvedPositionnData?.sales_rate || currentSelectedOrder?.sales_rate }}
                    setInput={setInitialInput} input={initialInput} name={"initial"} setStandardId={setStandardId} setTatDays={setTatDays}
                />

            )
            }


            {confirmationPopup && <CreateApprovaCaution handleClose={() => {
                setConfirmationPopup(false)

            }}

                onClose={() => {
                    setConfirmationPopup(false)
                    setAcceptAll(false)
                }}
                open={confirmationPopup}
                popupValues={popupValues}
                setAcceptAll={setAcceptAll}
                acceptAll={acceptAll}
                tabName={"core"}
                handleSubmit={handlePopUp}
                planningVerfication={planningVerfication}
                payload={formvalues}
                workshopOrderId={currentSelectedOrder?.id}
            />
            }
            {
                messagePopup && action === null &&
                <MessagePopup
                    handleClose={() => setMessagePopup(false)}
                    open={messagePopup}
                    topTitle={"The Commercial Reports for the job are being prepared"}
                    bottomTitle={"Please be patient, this will take a few moments"}

                />
            }









        </div >
    )
}
